import {Component, OnInit} from '@angular/core';
import { ConfigService } from 'src/app/services/config.service';
//import {Auth} from "../../classes/auth";

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {

  constructor(
    public config: ConfigService
  ) {
  }

  ngOnInit(): void {
  }

  //canAccess(permissions) {
  //  return Auth.canAccess(permissions);
  //}
}
